<template>
  <div class="content-430">
    <div class="class-form-head">报名设置</div>
    <div class="class-form-content">
      <Form
        ref="enrollSettingInfo"
        :model="enrollSettingInfo"
        label-position="right"
        :label-width="120"
        :rules="enrollSettingInfoRule"
        @on-validate="getFormValidate"
      >
        <FormItem label="报名开始时间" prop="enrollTimeBegin">
          <DatePicker
            v-model="enrollSettingInfo.enrollTimeBeginShow"
            type="datetime"
            placeholder="选择时间"
            clearable
            class="class-form-item"
            :options="beginDateOption"
            @on-change="handleGetEndTime($event, 'enrollTimeBegin')"
          ></DatePicker>
        </FormItem>
        <FormItem label="报名截止时间" prop="enrollTimeEnd">
          <DatePicker
            v-model="enrollSettingInfo.enrollTimeEndShow"
            type="datetime"
            placeholder="选择时间"
            clearable
            class="class-form-item"
            :options="endDateOption"
            @on-change="handleGetEndTime($event, 'enrollTimeEnd')"
          ></DatePicker>
        </FormItem>
        <FormItem label="最大报名人数" prop="studentTotal">
          <Input
            v-model="enrollSettingInfo.studentTotal"
            placeholder="请填写"
            class="w-40"
          ></Input>
          <span class="ml-2">人</span>
          <div>课程商品最大库存数，不填写则不限制</div>
        </FormItem>

        <FormItem label="报名范围" prop="visibleDTOList">
          <input
            v-model="enrollSettingInfo.visibleDTOList"
            type="text"
            hidden
          >
          <div
            v-if="!enrollSettingInfo.visibleDTOList.length"
            class="add-btn"
            @click="handleBookRange"
          >
            <div class="line"></div>
            <Icon type="md-add" size="20" color="#488ffa"></Icon>
            <span>圈定范围</span>
          </div>
          <span
            v-if="
              enrollSettingInfo.visibleDTOList.length === 1 &&
                enrollSettingInfo.visibleDTOList[0].gradeId === '0'
            "
            class="mb-1"
          >校区全部</span>
          <span
            v-if="enrollSettingInfo.visibleDTOList.length"
            class="a-cursor ml-1 mb-1"
            @click="handleBookRange"
          >重新圈定</span>
          <div
            v-if="
              enrollSettingInfo.visibleDTOList.length > 1 ||
                (enrollSettingInfo.visibleDTOList.length == 1 &&
                  enrollSettingInfo.visibleDTOList[0].gradeId != '0')
            "
            class="w1000 mb-1"
          >
            <tr class="book-title">
              <td
                v-for="(book, index) in bookTableColumns"
                :key="'book' + index"
                class="book w200"
              >
                {{ book.title }}
              </td>
            </tr>
            <div
              v-for="(vis1, index) in enrollSettingInfo.visibleDTOList"
              :key="'vis1' + index"
            >
              <div
                v-if="
                  vis1.gradeId != '0' &&
                    enrollSettingInfo.visibleDTOList.length > 0 &&
                    vis1.classId == '0'
                "
              >
                <tr>
                  <td class="book w200">{{ vis1.gradeName }}</td>
                  <td class="book w200">
                    {{ vis1.limitCount > 0 ? vis1.limitCount : '不限制' }}
                  </td>
                  <td class="book w200">/</td>
                  <td class="book w200">/</td>
                </tr>
                <div
                  v-for="(vis2, index2) in enrollSettingInfo.visibleDTOList"
                  :key="'vis2' + index2"
                >
                  <tr
                    v-if="vis2.classId != '0' && vis2.gradeId == vis1.gradeId"
                    class="bg"
                  >
                    <td class="book w200"></td>
                    <td class="book w200"></td>
                    <td class="book w200">
                      {{ vis2.className }}
                    </td>
                    <td class="book w200">
                      {{ vis2.limitCount > 0 ? vis2.limitCount : '不限制' }}
                    </td>
                  </tr>
                </div>
              </div>
            </div>
          </div>

          <div v-if="studentList.length > 0">
            <!-- <div v-for="(item, index) in showStudentList" :key="index">
              {{ item.studentName }}
            </div> -->
            <p style="padding-top: 8px">
              {{ getStudentListNameStr(studentList) }}
            </p>
          </div>
          <div>课程商品仅报名范围内学生可报名，不设置则全校可报</div>
        </FormItem>
      </Form>
    </div>
    <SelectBookRangeModal
      :id="schoolId"
      :school-id="schoolId"
      :stu-ids-list="stuIdsList"
      :branchid="branchId"
      :data="enrollSettingInfo.visibleDTOList"
      :visible="bookRangeModalShow"
      :classroom-id="classroomId"
      @close="bookRangeModalShow = !bookRangeModalShow"
      @return="handleReturnBookRange"
      @returnSucStu="returnSucStu"
    ></SelectBookRangeModal>
    <ChooseBookRangeModal
      ref="chooseBookRangeModalRef"
      :school-id="schoolId"
      :classroom-id="classroomId"
      @on-finish="onChooseBookRange"
    ></ChooseBookRangeModal>
  </div>
</template>
<script>
import SelectBookRangeModal from './SelectBookRangeModal.vue';
import ChooseBookRangeModal from './ChooseBookRangeModal.vue';

import { bookTableColumns } from '../data/commodity.js';
export default {
  components: {
    SelectBookRangeModal,
    ChooseBookRangeModal
  },
  inject: ['AddCommodityInstance'],
  props: {
    classroomId: {
      type: String,
      default: ''
    },
    schoolId: {
      type: String,
      default: ''
    },
    branchId: {
      type: String,
      default: ''
    },
    exsitOrder: {
      type: Boolean,
      default: false
    }, // 商品是否已被购买，是否存在订单
    value: {
      type: Object,
      default: () => {
        return {
          enrollTimeBegin: '',
          enrollTimeBeginShow: '',
          enrollTimeEnd: '', // 报名截止时间
          enrollTimeEndShow: '', // 展示
          studentTotal: '', // 班级总人数
          visibleDTOList: [
            // 可见范围
            // {
            //   'visibleId': 0, // 可见范围Id
            //   'orgId': 0, // 学校Id
            //   'branchId': 0, // 校区Id
            //   'gradeId': 0, // 年级Id
            //   'classId': 0, // 班级Id
            //   'limitCount': 0 // 人数限制
            // }
          ],

          isLimitEnroll: 0, // 圈定范围：0不限制 1按年级班级圈定 2限制个人
          stuIds: [] // 圈定范围为个人时被圈定的学生ids
        };
      }
    }, // v-model的值
    validatePass: {
      type: Boolean,
      default: false
    },
    isCopy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 最大报名人数规则
    const validateBookNum = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!Number.isInteger(+value) || value <= 0) {
        // this.enrollSettingInfo.studentTotal = null;
        callback(new Error('请输入大于0的整数'));
      } else {
        callback();
      }
    };
    const validateEndDateTime = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择报名截止时间'));
      } else if (
        this.enrollSettingInfo.enrollTimeBeginShow &&
        this.enrollSettingInfo.enrollTimeBeginShow.valueOf() >=
        new Date(value).valueOf()
      ) {
        callback(new Error('报名截止时间不能小于报名开始时间'));
      } else {
        callback();
      }
    };
    return {
      enrollSettingInfoRule: {
        enrollTimeBegin: [
          {
            required: true,
            message: '请选择报名开始时间',
            trigger: 'change'
          }
        ],
        enrollTimeEnd: [
          {
            required: true,
            trigger: 'change',
            validator: validateEndDateTime
          }
        ],
        studentTotal: [{ validator: validateBookNum, trigger: 'blur' }]
      },
      // 设置不可选时间
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      bookRangeModalShow: false,
      stuIdsList: [], // 圈定报名范围学生id
      stuIdsShowList: [],
      studentList: [],
      // isLimitEnroll: 0, // 圈定范围：0不限制 1按年级班级圈定 2限制个人
      bookTableColumns: bookTableColumns,
      enrollSettingInfoRequired: {}
    };
  },
  computed: {
    beginDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          // 如果有结束日期的话
          if (that.enrollSettingInfo.enrollTimeEndShow) {
            status =
              date &&
              date.valueOf() <
              that.enrollSettingInfo.enrollTimeEndShow.valueOf();
          }
          return !status;
        }
      };
    },
    endDateOption() {
      const that = this;
      return {
        disabledDate(date) {
          let status = true;
          const nowTime = Date.now();
          const beginTime = that.enrollSettingInfo.enrollTimeBeginShow
            ? that.enrollSettingInfo.enrollTimeBeginShow.valueOf()
            : '';
          const line = beginTime;

          status = date && date.valueOf() > line - 24 * 60 * 60 * 1000;
          return !status;
        }
      };
    },
    enrollSettingInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }, // 课程信息
    showStudentList() {
      return this.studentList.filter((item, index) => { return index < 5; });
    }
  },
  watch: {
    enrollSettingInfo: {
      handler(newVal, oldVal) { },
      deep: true
    }
  },
  created() {
    this.dealFormRequire();
  },
  mounted() {
    this.AddCommodityInstance.findRuleRequireNewCourse(
      this,
      'enrollSettingInfo',
      '报名设置'
    );
  },
  methods: {
    getStudentListNameStr(list) {
      const names = list.map(item => { return item.studentName; });
      return names.join('，');
    },
    //
    onChooseBookRange(res) {
      this.enrollSettingInfo.isLimitEnroll = res.isLimitEnroll;
      if (res.isLimitEnroll == 1) {
        //  console.log(data, '======圈定报名范围，班级的-----');
        // this.isLimitEnroll = data.isLimitEnroll;

        this.enrollSettingInfo.visibleDTOList = res.data;
        // this.bookRangeModalShow = !this.bookRangeModalShow;
        delete this.enrollSettingInfo.stuIds;
        this.studentList = [];
      } else if (res.isLimitEnroll == 2) {
        this.enrollSettingInfo.visibleDTOList = [];
        this.studentList = res.data;
        this.enrollSettingInfo.stuIds = res.data.map(item => { return item.studentId; });
      } else {
        this.enrollSettingInfo.visibleDTOList = [];
        this.studentList = [];
        // const list = data.stuIds;
        // const arr = [];
        // this.stuIdsShowList = [];
        // for (let i = 0; i < list.length; i++) {
        //   if (i < 5) {
        //     this.stuIdsShowList.push(list[i]);
        //   }
        //   arr.push(list[i].value);
        // }
      }
    },
    getFormValidate(prop, status, error) {
      this.enrollSettingInfoRequired[prop].status = status;
      this.AddCommodityInstance.findRuleRequireNewCourse(
        this,
        'enrollSettingInfo',
        '报名设置'
      );
    },
    dealFormRequire() {
      Object.keys(this.enrollSettingInfoRule).forEach((item) => {
        this.enrollSettingInfoRequired[item] = {
          require: !!this.enrollSettingInfoRule[item][0].required,
          status: false
        };
      });
    },
    // 校验表单
    checkForm() {
      if (this.enrollSettingInfo.visibleDTOList.length > 0) {
        this.enrollSettingInfo.visibleDTOList =
          this.enrollSettingInfo.visibleDTOList.map((item) => {
            item.limitCount = 0;
            const { visibleId, classroomId, ...obj } = item;
            return this.classroomId && !this.isCopy
              ? { classroomId: this.classroomId, ...obj }
              : obj;
          });
      }
      this.$refs.enrollSettingInfo.validate();
      // this.$refs.enrollSettingInfo.validate((valid) => {
      //   if (valid) {
      //     this.$emit('update:validatePass', true);
      //   } else {
      //     this.AddCommodityInstance.findRuleRequireNewCourse(this, 'enrollSettingInfo', '报名设置', true);
      //     this.$emit('update:validatePass', false);
      //   }
      // });
    },
    // 点击选择固定范围
    handleBookRange() {
      if (!this.branchId) {
        this.$Message.warning('请先选择学校校区');
      } else {
        const data = {
          isLimitEnroll: this.enrollSettingInfo.isLimitEnroll,
          list: this.enrollSettingInfo.isLimitEnroll == 1 ? this.enrollSettingInfo.visibleDTOList.map(item => { return { id: item.gradeId, ...item }; }) : this.studentList.map(item => { return { id: item.studentId, gradeClassName: item.gradeName + item.className, ...item }; })
        };
        this.$refs.chooseBookRangeModalRef.open(data);
        //  this.bookRangeModalShow = !this.bookRangeModalShow;
      }
    },
    // 固定报名范围 - 班级
    handleReturnBookRange(data) {
      console.log(data, '======圈定报名范围，班级的-----');
      // this.isLimitEnroll = data.isLimitEnroll;
      this.enrollSettingInfo.isLimitEnroll = data.isLimitEnroll;
      this.enrollSettingInfo.visibleDTOList = data.arr;
      this.bookRangeModalShow = !this.bookRangeModalShow;
      delete this.enrollSettingInfo.stuIds;
      this.stuIdsShowList = [];
    },
    handleGetEndTime(time, key) {
      console.log(time, '=============');
      this.enrollSettingInfo[key] = time;
    },
    // 固定报名范围 - 个人
    returnSucStu(data) {
      this.enrollSettingInfo.visibleDTOList = [];
      // this.isLimitEnroll = data.isLimitEnroll;
      const list = data.stuIds;
      const arr = [];
      this.stuIdsShowList = [];
      for (let i = 0; i < list.length; i++) {
        if (i < 5) {
          this.stuIdsShowList.push(list[i]);
        }
        arr.push(list[i].value);
      }
      this.enrollSettingInfo.isLimitEnroll = data.isLimitEnroll;
      this.enrollSettingInfo.stuIds = arr;
      this.bookRangeModalShow = !this.bookRangeModalShow;
    }
  }
};
</script>
<style lang="scss" scoped>
.add-btn {
  width: 95px;
  height: 30px;
  border: 1px dashed transparent;
  background: linear-gradient(white, white) padding-box,
    repeating-linear-gradient(
      -45deg,
      #488ffa 0,
      #488ffa 0.5em,
      white 0,
      white 0.75em
    );
  color: #488ffa;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;

  .icon {
    margin-right: 2px;
  }
}
.book-title {
  background-color: rgb(247, 248, 250);
  font-weight: 700;

  tr {
    border: 1px solid rgb(247, 248, 250);
  }
}

.book {
  line-height: 50px;
  text-indent: 10px;
}

.w100 {
  width: 100px;
}

.w200 {
  width: 200px;
}

.w1000 {
  width: 800px;
}

.bg {
  background-color: rgb(247, 248, 250);
}
.a-cursor {
  color: #488ffa;
  cursor: pointer;
}
.ml-1 {
  margin-left: 4px;
}
.mb-1 {
  margin-bottom: 4px;
}
</style>
